<script setup lang="ts">
import { computed } from 'vue';
import { getStoreDescription } from '../storeTypes';

const props = defineProps<{
    storeType: string;
}>();

const description = computed(() => getStoreDescription(props.storeType));
</script>

<template>
    <div class="store-description-wrapper">
        <img v-if="description.image" :src="require(`@/assets/images/${description.image}`)" alt="store logo" />
        <h1 class="m-0">{{ description.title }}</h1>
        <p>{{ description.summary }}</p>
        <ul class="benefit-list">
            <li v-for="(benefit, idx) in description.benefits" :key="`benefit-${idx}`">
                <span class="benefit-icon">
                    <font-awesome-icon icon="fa-solid fa-check" />
                </span>
                {{ benefit }}
            </li>
        </ul>
        <div class="review-container mt-3">
            <div v-for="(review, idx) in description.reviews" :key="`review-${idx}`" class="review">
                <div class="color-yellow">★★★★★</div>
                <div class="font-italic my-2">"{{ review.content }}"</div>
                <div class="review-author">
                    <img :src="require(`@/assets/images/reviews/${review.avatar}`)" :alt="review.store" />
                    <div>
                        <span class="review-store">{{ review.store }}</span>
                        <span class="review-country">{{ review.country }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import 'styles/utilities/functions';

.store-description-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    color: get-color('white');
    p {
        margin: 0;
        font-size: 0.825rem;
        font-weight: 700;
    }
    img {
        width: fit-content;
        max-height: 3.75rem;
        max-width: 12.5rem;
    }
    .benefit-list {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin: 0;
        padding: 0;
        list-style: none;
        font-size: 0.825rem;
        li {
            display: flex;
            align-items: center;
            gap: 0.625rem;
        }
        .benefit-icon {
            display: inline-flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
            width: 1.125rem;
            height: 1.125rem;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.25);
            font-size: 0.6rem;
        }
    }
    .review-container {
        display: flex;
        gap: 1rem;
        .review {
            padding: 1rem;
            border-radius: 0.75rem;
            background: rgba(255, 255, 255, 0.12);
        }
        .review-author {
            display: flex;
            align-items: center;
            gap: 0.625rem;
            img {
                flex-shrink: 0;
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                object-fit: cover;
            }
        }
        .review-store {
            font-size: 0.825rem;
            font-weight: 700;
        }
        .review-country {
            font-size: 0.75rem;
            color: rgba(255, 255, 255, 0.6);
        }
    }
}
</style>
